import React, { useMemo } from "react";
import { overlayBase } from "./_shared";

interface Props {
  /** URL of the transparent PNG sprite (car, truck, etc.) */
  spriteUrl: string;
  /** Starting left position, default "-10%" */
  from?: string;
  /** Ending left position, default "70%" */
  to?: string;
  /** [startScale, endScale] for perspective depth, default [0.5, 1] */
  scale?: [number, number];
  /** Travel duration seconds, default 6 */
  dur?: number;
  /** Vertical position from top, default "68%" */
  top?: string;
  /** Sprite image width px, default 160 */
  width?: number;
}

/**
 * Sprite — a transparent PNG (car / truck / person / etc.) translating
 * across the banner with optional scale change for a depth effect.
 */
const Sprite: React.FC<Props> = ({
  spriteUrl,
  from = "-10%",
  to = "70%",
  scale = [0.5, 1],
  dur = 6,
  top = "68%",
  width = 160,
}) => {
  // Unique keyframe name per instance to avoid collisions when multiple
  // Sprite effects are on screen simultaneously.
  const kfName = useMemo(
    () => `oot-sprite-${Math.random().toString(36).slice(2, 8)}`,
    []
  );

  return (
    <div style={overlayBase}>
      <style>{`
        @keyframes ${kfName} {
          0%   { left: ${from}; transform: scale(${scale[0]}); }
          100% { left: ${to};   transform: scale(${scale[1]}); }
        }
      `}</style>
      <img
        src={spriteUrl}
        alt=""
        style={{
          position: "absolute",
          top,
          width,
          left: from,
          animation: `${kfName} ${dur}s ease-in-out infinite alternate`,
        }}
      />
    </div>
  );
};

export default Sprite;
